import React from "react";
import apiClient from "api/client";
import Button from "../CustomButton/CustomButton.jsx";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {OverlayTrigger, Tooltip, InputGroup, Row, Grid, Col, FormGroup} from "react-bootstrap";
import ModalDelete from "../CustomModals/ModalDelete";
import {ModalContentProvider} from "../CustomModals/ModalContentProvider";
import ReactTableV6Simple from "../CustomDataTables/ReactTableV6Simple";
import Card from "../Card/Card";
import {loadImage} from "../../functions/LoadImages";

class DataContentProviders extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            edit_content_provider_tooltip: (<Tooltip id="edit_tooltip">Edit</Tooltip>),
            remove_content_provider_tooltip: (<Tooltip id="remove_tooltip">Remove</Tooltip>),

            redirect: false,
            content_provider_id: 1,
            loading: true,
            contentProvidersArray: [],
            lastSelectedContentProvider: [],
            showDeleteModal: false,
            showContentProviderModal: false,
            searchContentProvider: "",
            filter: null,

            columns: [
                {
                    accessor: "content_provider_id",
                    Header: "ID",
                    maxWidth: 80,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "content_provider_name",
                    Header: "Name",
                    maxWidth: 450,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "content_provider_description",
                    Header: "Description",
                    maxWidth: 450,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "content_provider_logo",
                    Header: "Logo",
                    sortable: true,
                    maxWidth: 200,
                    filterable: false,
                    Cell: row => (
                        <div className="center">
                            <img
                                src={loadImage.load_content_provider_image(row.value)}
                                // width="90%"
                                height="60px"
                                alt={""}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = process.env.REACT_APP_ASSET_URL + "/global/landscape_image_broken.png"
                                }}
                            />
                        </div>
                    )
                },
                {
                    Header: 'actions',
                    maxWidth: 200,
                    sortable: false,
                    filterable: false,
                    accessor: "content_provider_id",
                    Cell: row => (
                        <div className="actions-right">
                            {this.setHelperButton(row.value)}
                            {this.setDeleteButton(row.value)}
                        </div>
                    )
                }
            ],
            data: []

        };

        this.setDisplayModal = this.setDisplayModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }


    handleInputChange(event) {

        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        let dt = new Date();
        let utcDate = dt.toUTCString();

        if (name === "searchContentProvider") {

            this.setState({
                lastUpdate: utcDate,
                filtered: [''],
                filter: value,
                activePage: 1,
                searchContentProvider: value
            })

            this.loadContentProvidersPost(value);
        }

    }

    setHelperButton(content_provider_id) {

        return (<OverlayTrigger placement="top" overlay={this.state.edit_content_provider_tooltip}>
            <Button
                onClick={() => this.setState({
                    showContentProviderModal: true,
                    content_provider_id: content_provider_id
                })}

                bsStyle="info"
                simple
                icon
            >
                <i className="fa fa-edit"/>
            </Button>
        </OverlayTrigger>)

    }

    setDeleteButton(content_provider_id) {

        return (<OverlayTrigger placement="top" overlay={this.state.remove_content_provider_tooltip}>
            <Button
                onClick={() => this.setState({showDeleteModal: true, content_provider_id: content_provider_id})}

                bsStyle="danger"
                simple
                icon
            >
                <i className="fa fa-times"/>
            </Button>
        </OverlayTrigger>)

    }

    setDisplayModal = (id, value) => {

        let device = this.findArrayElementByID(this.state.contentProvidersArray, id)

        this.setState({
            showModal: value,
            decoder_id: id,
            lastSelectedDevice: device

        })
    }

    componentDidMount() {

        this.loadContentProviders();

    }

    loadContentProviders() {

        this.setState({loading: true});

        let dataUrl = process.env.REACT_APP_API_URL + "/ContentProviders";

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };

        apiClient.get(dataUrl, axiosConfig).then(res => {
            const contentProvidersArray = res.data;
            const loading = false;
            this.setState({contentProvidersArray, loading});
        }).catch(error => {
            this.setState({loading: false});
            //this.props.dispatch(userActions.logoutUnauthorized());
            console.log(error);
        });
    }

    loadContentProvidersPost(value) {

        this.setState({loading: true});

        let dataUrl = process.env.REACT_APP_API_URL + "/ContentProviders";

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json',
            }
        };

        var postData = {
            type: "list",
            searchProvider: value
        }

        apiClient.post(dataUrl, postData, axiosConfig).then(res => {
            const contentProvidersArray = res.data;
            const loading = false;
            this.setState({contentProvidersArray, loading});
        }).catch(error => {
            this.setState({loading: false});
            //this.props.dispatch(userActions.logoutUnauthorized());
            console.log(error);
        });

    }

    deleteContentProvider() {

        const deleteURL = process.env.REACT_APP_API_URL + "/ContentProviders/" + this.state.content_provider_id;

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token
            }
        };

        apiClient.delete(deleteURL, axiosConfig)
            .then((res) => {
                this.loadContentProviders();
                //this.props.handlerFromParent();
                this.setState({content_provider_id: null});
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.props.dispatch(userActions.logoutUnauthorized());
            })


    }

    setDeleteContentProviderModal = (id, value, action) => {

        this.setState({
            showDeleteModal: value
        })

        if (action === "delete") {
            this.deleteContentProvider();

        }


    }

    setEditContentProviderModal = (id, value, action) => {

        this.setState({
            showContentProviderModal: value,
            content_provider_id: null
        })

        if (action === "reload") {
            this.loadContentProviders();
            //this.props.handlerFromParent();
        }

    }

    renderDeleteContentProviderModal = () => {

        let bodyMessageVar = "this action will delete the content provider.";

        if (this.state.showDeleteModal) {
            return <ModalDelete
                headerMessage={"Delete Content Provider"}
                bodyMessage={bodyMessageVar}
                handlerFromParent={this.setDeleteContentProviderModal}
                handlerID={this.state.content_provider_id}
            />
        }
    }

    renderContentProviderModal = () => {

        let bodyMessageVar = "";

        if (this.state.showContentProviderModal) {
            return <ModalContentProvider
                headerMessage={"Edit Content Provider"}
                bodyMessage={bodyMessageVar}
                handlerFromParent={this.setEditContentProviderModal}
                handlerID={this.state.content_provider_id}
            />
        }
    }

    clearSearchButton() {

        let dt = new Date();
        let utcDate = dt.toUTCString();
        let value = "";

        // if (this.props.listState === "removed") {
        //     set.removed_page_filter(value)
        //     set.removed_page("1")
        // } else {
        //     set.active_page_filter(value)
        //     set.active_page("1")
        // }

        this.setState({
            lastUpdate: utcDate,
            filtered: [''],
            filter: value,
            activePage: 1,
            searchContentProvider: ""
        })

        this.loadContentProviders();

    }

    render() {
        return (
            <div>

                {/*{this.renderRedirect()}*/}
                {this.renderDeleteContentProviderModal()}
                {this.renderContentProviderModal()}

                <Card
                    content={
                        <div>
                            <div>
                                <Grid fluid>
                                    <Row>
                                        <Col md={12}>
                                            <div className="pull-left">
                                                <h5>
                                                    {this.props.listName}
                                                </h5>
                                            </div>
                                            <div className="pull-left">
                                                <Button bsStyle="info" fill bsSize="xs"
                                                        style={{marginLeft: "10px", marginTop: "10px"}}
                                                        onClick={() => this.setState({
                                                            showContentProviderModal: true,
                                                            content_provider_id: "new"
                                                        })}
                                                >
                                                    {/*<i className="fa fa-plus-circle fa-lg"/>*/}
                                                    Add new content provider
                                                </Button>
                                            </div>
                                            <div className="pull-right" style={{width: "250px"}}>
                                                <FormGroup>
                                                    <InputGroup>
                                                        <input
                                                            className="form-control form-control-sm ml-3 w-75"
                                                            type="text"
                                                            placeholder="Search"
                                                            aria-label="Search"
                                                            name="searchContentProvider"
                                                            onChange={this.handleInputChange}
                                                            value={this.state.searchContentProvider || ""}
                                                        />
                                                        <InputGroup.Addon>
                                                            <i style={{color: this.state.searchContentProvider !== "" ? "#f7263b" : "#343434"}}
                                                               className={this.state.searchContentProvider !== "" ? "fa fa-times" : "fa fa-search"}
                                                               onClick={this.clearSearchButton.bind(this)}/>
                                                        </InputGroup.Addon>
                                                    </InputGroup>
                                                </FormGroup>

                                            </div>

                                        </Col>
                                    </Row>
                                </Grid>
                            </div>

                            <legend/>


                            <ReactTableV6Simple
                                data={this.state.contentProvidersArray}
                                loading={this.state.loading}
                                columns={this.state.columns}
                                defaultPageSize={5}
                            />

                        </div>
                    }
                />

            </div>
        );

    }
}

function mapStateToProps(state) {

    const {users, authentication} = state;
    const {user} = authentication;
    return {
        user,
        users
    };
}

const connectedDataContentProviders = connect(mapStateToProps)(DataContentProviders);
export {connectedDataContentProviders as DataContentProviders};